/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Total_PaidInputs */

const en_confirm_total_paid = /** @type {(inputs: Confirm_Total_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total paid to date`)
};

const he_confirm_total_paid = /** @type {(inputs: Confirm_Total_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סך ששולם עד היום`)
};

/**
* | output |
* | --- |
* | "Total paid to date" |
*
* @param {Confirm_Total_PaidInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_total_paid = /** @type {((inputs?: Confirm_Total_PaidInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Total_PaidInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_total_paid(inputs)
	return he_confirm_total_paid(inputs)
});